<span
  class="ctx-table__paginator box-border flex flex-row items-center w-full justify-between px-4 py-3 border-0 border-t-2 border-b border-solid overflow-auto"
>
  <!-- Page size and column actions -->
  <span class="flex flex-row gap-x-4 items-center mr-2">
    <!-- Column selection -->
    <mat-form-field color="accent" class="mat-mdc-form-field--xs">
      <hlm-icon name="COLUMNS" matPrefix inline class="mx-2 xs"></hlm-icon>
      <mat-select
        aria-hidden="true"
        multiple
        [(value)]="resourceTableService.columnIdsToDisplay"
        #columnSelect
      >
        <mat-select-trigger>
          {{ resourceTableService.columnIdsToDisplay.length }} Columns
        </mat-select-trigger>
        <mat-optgroup label="Selected Columns">
          <mat-option value="id">{{
            getResourceDisplayName('id', projectName)
          }}</mat-option>

          @for (column of resourceTableService.columns; track column) {
          <mat-option class="text-xs" [value]="column.property">{{
            getResourceDisplayName(column.property, projectName)
          }}</mat-option>
          }
          <mat-option disabled value="createdAt">{{
            getResourceDisplayName('createdAt', projectName)
          }}</mat-option>
        </mat-optgroup>
      </mat-select>
    </mat-form-field>

    <!-- Page size -->
    <mat-form-field color="accent" class="mat-mdc-form-field--xs w-24">
      <hlm-icon name="ROWS" matPrefix inline class="mx-2 xs"></hlm-icon>
      <mat-select
        aria-hidden="true"
        (selectionChange)="handlePageSizeChange($event)"
        [value]="resourceTableService.tablePageSize"
      >
        <mat-optgroup label="Rows">
          @for ( pageSizeOption of resourceTableService.tablePageSizeOptions ;
          track pageSizeOption) {
          <mat-option [value]="pageSizeOption">
            <span class="whitespace-nowrap">{{ pageSizeOption }}</span>
          </mat-option>
          }
        </mat-optgroup>
      </mat-select>
    </mat-form-field>
  </span>

  <!-- Pagination actions and status label -->
  <span class="flex flex-row gap-4 items-center ml-2">
    <!-- Range label -->
    <span class="text-xs opacity-60 whitespace-nowrap">
      {{ rangeLabel }}
    </span>

    <!-- Buttons -->
    <span
      class="flex flex-row gap-4 items-center"
      [ngClass]="isIntercomVisible ? 'mr-14' : ''"
    >
      @if (showFirstLastButtons) {
      <button
        ctx-button--secondary
        actionIcon="FIRST_PAGE"
        type="button"
        (click)="firstPage()"
        color="accent"
        aria-label="First page"
        title="First page"
        [disabled]="previousButtonsDisabled"
      ></button>
      }
      <button
        ctx-button--secondary
        type="button"
        color="accent"
        actionIcon="PREVIOUS_PAGE"
        aria-label="Previous page"
        title="Previous page"
        (click)="previousPage()"
        [disabled]="previousButtonsDisabled"
      ></button>
      <button
        ctx-button--secondary
        type="button"
        color="accent"
        actionIcon="NEXT_PAGE"
        aria-label="Next page"
        title="Next page"
        (click)="nextPage()"
        [disabled]="nextButtonsDisabled"
      ></button>
      @if (showFirstLastButtons) {
      <button
        ctx-button--secondary
        actionIcon="LAST_PAGE"
        type="button"
        color="accent"
        aria-label="Last page"
        title="Last page"
        (click)="lastPage()"
        [disabled]="nextButtonsDisabled"
      ></button>
      }
    </span>
  </span>
</span>
